
/**
 * @fileOverview Footer Button View Module
 * @Author: a3xs8zz
 * @modified 02/02/2015
 *
 */

(function (context) {
    'use strict';
    var require = context.require;
    var requirejs = context.requirejs;
    var define = context.define;

    define('views/FooterBtnView',['require','jquery','lib/Util'],function (require) {
        var $ = require('jquery');
        var Util = require('lib/Util');

        
        var FooterBtnView = function ($element) {
        	this.element = $element;

			this.init();
        };

		FooterBtnView.prototype.init = function(){
            var withDataAndEvents = true;
            var $nonMobileBtn = this.element.clone(withDataAndEvents).removeClass('MMM--btn MMM--btn_tertiary mix-MMM--btn_linkInMobileOnly mix-MMM--btn_fullWidthMobileOnly');
            // Clone each button and it attached events and data then remove the button classes from it
            // Add appropriate classes to show or hide the original button and its clone on the appopriate devices
            this.element.after($nonMobileBtn);
            $nonMobileBtn.wrap('<span class="MMM--isNotOnMobile"></span>');
            this.element.wrap('<span class="MMM--isOnMobile MMM--isNotOnTablet"></span>');
		};
        
        return FooterBtnView;
    });

}(MMMRequire));